import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';

export const deleteDataset = async (
  collectionId: string,
  datasetId: string,
) => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest({
    url: `/collections/${orgId}/${collectionId}/datasets/${datasetId}`,
    method: 'DELETE',
    target: 'platform',
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to delete dataset',
    };
  }

  return response;
};
